module.exports = __webpack_public_path__ + "img/logo-ALCP-tmp.5c4a39be.svg";